var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWfjKOvsF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "wsw3w2u6sb",
    cx: 24,
    cy: 24,
    r: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1151.000000, -698.000000) translate(1151.000000, 698.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bxvs8h3oda)",
    xlinkHref: "#wsw3w2u6sb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#wsw3w2u6sb"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2593FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.891 20.966L24 32.075 35.109 20.966",
    transform: "translate(-1151.000000, -698.000000) translate(1151.000000, 698.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWfjKOvsF);
export default __webpack_public_path__ + "static/media/wfjKOvsF.28b348bd596f8a55acaa6a67c274c41f.svg";
export { ForwardRef as ReactComponent };